var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('router-link',{staticClass:"brands__item",attrs:{"to":{ name: 'catalog', query: { brands_item_id: _vm.data.id } },"title":_vm.data.title}},[_c('ImgComponent',{staticClass:"brands__item-img",attrs:{"head_img":_vm.data.head_img,"contain":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }